export { default } from "./BlogTile";
